import {
  TabDetailPanelSettings,
} from '@common-modules/dependencies/navigation/tab-detail-component';
import { TabDetailPanelParameters } from '@common-modules/dependencies/navigation/tab-detail-panel-parameters';
import { Observable } from 'rxjs';

export abstract class SidePanelService {
  abstract readonly visibility$: Observable<boolean>;
  abstract readonly hover$: Observable<boolean>;
  abstract readonly hasPanel$: Observable<boolean>;

  abstract toggleVisibility(): void;
  abstract toggleHover(): void;

  abstract setTabSettings(settings: TabDetailPanelSettings);
  abstract setTabParameters(params: TabDetailPanelParameters);
}
